export const getVisibleCustomerTables = (tables, isSubuser) =>
  (tables || []).filter((table) => !(isSubuser && table?.header === "Coupons"));
